import { Button, FormControl, TextField } from "@mui/material";
import { Col, Row } from "antd";
import PasswordStrength from "./PasswordLength.js";
import Loading from "components/Ui/Loading.jsx";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import axios from "axios";
import { useParams } from "react-router-dom";
import { request } from "services/api.js";

export default function DefinePassword() {
    const [loading, setLoading] = useState(true);
    const [invalidToken, setInvalidToken] = useState(true);
    const [invalidOperation, setInvalidOperation] = useState(false);

    const { passwordToken } = useParams();



    useEffect(() => {
        request.post('invitations/token/check', {
            token: passwordToken
        })
            .then((res) => {
                setInvalidToken(false)
            })
            .catch(err => setInvalidToken(true))
            .finally(() => setLoading(false))
        console.log('ici dude');
    }, [])
    const handleSubmit = (password) => {
        setLoading(true);
        request.post('invitations/define-password', {
            token: passwordToken,
            password
        })
            .then((res) => {
                // setInvalidToken(false)
                window.location = '/login'
            })
            .catch(err => setInvalidOperation(true))
            .finally(() => setLoading(false))
    };


    if (loading) {
        return <Loading />;
    }

    return (
        <div
            className="flex flex-col justify-center items-center"
            style={{ minHeight: "calc(100vh - 266px)" }}
        >
            {
                invalidToken ? <>
                    <h1 style={{ textAlign: 'center', padding: '0 20px' }}>Désolé le lien unique pour finaliser votre compte est invalide,
                        <br />
                        veuillez revérifier votre mail d'invitation pour vous assurer que vous avez bien copiez/cliquez sur le bon lien.</h1>
                </> : <>
                    <br /><br />
                    {
                        invalidOperation && <p className="MuiFormHelperText-root Mui-error
                        MuiFormHelperText-sizeMedium MuiFormHelperText-contained MuiFormHelperText-filled 
                        " >Une erreur est survenue pendant l'ajout de votre mot de passe,
                            veuillez reessayer</p>
                    }
                    <PasswordForm onSubmit={handleSubmit} />
                </>
            }
        </div>
    );
}

function PasswordForm({ onSubmit }) {
    const [strongPWD, setStrongPWD] = React.useState(false);

    const validationSchema = yup.object({
        password: yup
            .string()
            .required("Non valide, réessayer")
            .matches(
                /^(?=.*[A-Z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
                "Non valide, réessayer",
            ),
        passwordConfirm: yup
            .string()
            .required("Non valide, réessayer")
            .equals([yup.ref("password")], "Ces mots de passe ne correspondent pas"),
    });

    const formik = useFormik({
        initialValues: {
            password: "",
            passwordConfirm: "",
        },
        validationSchema,
        onSubmit: (values) => {
            if (strongPWD) {
                onSubmit(values.password);
            }
        },
    });

    return (
        <div className="max-w-[630px]">
            <h2
                className="font-sans text-2xl font-semibold mb-7"
                style={{ color: "#373737" }}
            >
                Identifiants
            </h2>
            <form onSubmit={formik.handleSubmit}>
                <p
                    className="font-sans font-normal text-xl mb-6"
                    style={{ color: "#373737" }}
                >
                    Créez un mot de passe
                </p>
                <div className="mb-8">
                    <small
                        className="font-sans text-xs font-normal"
                        style={{ color: "#373737" }}
                    >
                        Le mot de passe doit : contenir 8 caractères, être alphanumérique,
                        contenir une lettre majuscule contenir un caractère spécial
                    </small>
                </div>
                <Row gutter={15}>
                    <Col span={12}>
                        <div className="mb-4">
                            <FormControl fullWidth>
                                <TextField
                                    name="password"
                                    label={
                                        <p className="mr-1">
                                            Mot de Passe<span className="align-top">*</span>
                                        </p>
                                    }
                                    type="password"
                                    value={formik.values.password || ""}
                                    error={
                                        formik.touched.password && Boolean(formik.errors.password)
                                    }
                                    helperText={formik.touched.password && formik.errors.password}
                                    onChange={formik.handleChange}
                                />
                            </FormControl>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div className="mb-4">
                            <FormControl fullWidth>
                                <TextField
                                    name="passwordConfirm"
                                    label={<p className="mr-4">Confirmer votre mot de passe</p>}
                                    type="password"
                                    value={formik.values.passwordConfirm || ""}
                                    error={
                                        formik.touched.passwordConfirm &&
                                        Boolean(formik.errors.passwordConfirm)
                                    }
                                    helperText={
                                        formik.touched.passwordConfirm &&
                                        formik.errors.passwordConfirm
                                    }
                                    onChange={formik.handleChange}
                                />
                            </FormControl>
                        </div>
                    </Col>
                    <Col span={12}>
                        <PasswordStrength
                            value={formik.values.password}
                            onChange={(e) => setStrongPWD(e)}
                        />
                    </Col>
                </Row>

                <p className="mt-10">&nbsp;</p>
                <div className="flex justify-end">
                    <Button
                        size="large"
                        variant="outlined"
                        disableElevation
                        color="secondary"
                    >
                        Annuler
                    </Button>
                    <div className="ml-8">
                        <Button
                            size="large"
                            variant="outlined"
                            disableElevation
                            type="submit"
                        >
                            Soumettre
                        </Button>
                    </div>
                </div>
            </form>
        </div>
    );
}
